<template>
  <div class="DepartmentDynamics">
    <div class="content flex-jc-bt flex-no-wrap">
      <div class="flex-78 left-side">
        <sp-card type="none" custom-class="sp-color-bg-4">
          <div class="card-content">
            <div class="flex flex-al-center">
              <sp-button
                to="companiesDynamics"
                class="bt-item"
                :width="0.14"
                :height="44"
                circle-radius="5"
                type="warn"
                :bold="400"
                :font="18"
                :label="$l('CompaniesDynamics')"
              />
              <sp-button
                to="staffDynamics"
                class="bt-item mg-l-20"
                :width="0.1"
                :height="44"
                circle-radius="5"
                type="warn"
                :bold="400"
                :font="18"
                :label="$l('StaffDynamics')"
              />
              <sp-button
                to="orgnizationChart"
                class="bt-item mg-l-20"
                :width="0.12"
                :height="44"
                circle-radius="5"
                type="warn"
                :bold="400"
                :font="18"
                :label="$l('OrganizationChart')"
              />
              <!-- filter 弹出框 -->
              <!--              <FilterForm :access-identity-options="accessIdentityOptions" :company-category="companyCategory" /> -->
            </div>
            <sp-tag-group v-model="deptClass" class="tags">
              <sp-tag label="all" :width="100">
                {{ $l("All") }}
              </sp-tag>
              <sp-tag label="shipowner">
                {{ $l("Shipowners") }}
              </sp-tag>
              <sp-tag label="charterer">
                {{ $l("Charterers") }}
              </sp-tag>
              <sp-tag label="broker">
                {{ $l("Brokers") }}
              </sp-tag>
              <sp-tag label="operator">
                {{ $l("Operators") }}
              </sp-tag>
              <sp-tag label="deleted">
                {{ $l("Deleted") }}
              </sp-tag>
            </sp-tag-group>
            <!-- 表格左边部分 -->
            <SpTable v-model:currPage="currPage" column-height="114" show-arrow :data-list="dataList" width="1" class="table" :total="total" :page-size="pageSize" @afterExpand="getDeptEmployeeHistory">
              <SpTableColumn column-name="id" label="No" />
              <SpTableColumn column-name="codeName" width="120" label="CodeName" />
              <SpTableColumn column-name="DeptOrFunctional" width="300" label="DeptOrFuncTeam">
                <template #default="row">
                  <div>{{ row.name }}</div>
                  <div class="attach">
                    {{ row.nativeName }}
                  </div>
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="OfficeLocation" label="OfficeLocation">
                <template #default="row">
                  <div>{{ row.address }}</div>
                  <div class="attach">
                    {{ row.city?.name }} , {{ row.country?.name }}
                  </div>
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="AccessIdentity" label="AccessIdentity" width="160">
                <template #default="row">
                  {{ $l(accessIdentityOptions[row.identity]) }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Staff" label="Staff">
                <template #default="row">
                  {{ row.totalEmployed }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="More" :width="80">
                <template #default="row">
                  <sp-icon class="pointer" type="more" @click="showMoreDialog(row)" />
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Action" :width="80">
                <template #default="row">
                  <div v-if="deptClass=='deleted'" class="flex-jc-ard">
                    <el-popover
                      trigger="click" inline width="500" height="200" @show="getDeleter(row)">
                      <template #reference>
                        <sp-icon class="pointer" type="deleteBy" />
                      </template>
                      <DeleteBy :info="delInfo" />
                    </el-popover>

                    <sp-icon class="pointer" type="cancel" @click="toRecycle(row)" />
                    <sp-icon class="pointer" type="delete" @click="toDelete(row)" />
                  </div>
                  <div v-else class="flex-jc-ard">
                    <sp-icon class="pointer" type="edit" @click="goEdit(row)" />
                    <sp-icon class="pointer" type="delete" @click="toDelete(row)" />
                  </div>
                </template>
              </SpTableColumn>
              <!-- 这是箭头显示后展示的内容 -->
              <template #expand="row">
                <div class="expand flex">
                  <!-- 聘用职员的日志 -->
                  <div class="flex-align-center flex-col">
                    <router-link
                      class="link sp-color-6"
                      :to="{ name: 'addStaff', params:{ type: 'employment' },query: {deptId: row.id} }">
                      {{ $l('AddNewEmployee') }}({{ row.totalEmployed }})
                    </router-link>
                    <sp-popover :width="800">
                      <SpTable v-if="row.inService" :data-list="row.inService" class="popover-table" border="manul" type="none" :pop-data-style="{borderBottom:'1px solid #DBDBDB'}">
                        <SpTableColumn column-name="Staff" width="300" label="Staff">
                          <template #default="row">
                            <div class="pd-l-10 pd-r-10">
                              <div class="ellipsis">{{ row.employee?.fullName }}</div>
                              <div class="attach ellipsis">
                                {{ row.employee?.nativeName }}
                              </div>
                            </div>
                          </template>
                        </SpTableColumn>
                        <SpTableColumn column-name="JobDescription" :width="300" label="JobDescription">
                          <template #default="row">
                            <div class="ellipsis pd-l-10 pd-r-10">
                              {{ row.job?.description }}
                            </div>
                          </template>
                        </SpTableColumn>
                        <SpTableColumn column-name="StartingDate" label="StartingDate">
                          <template #default="row">
                            {{ getDateToFormatEn(row.hiredAt) }}
                          </template>
                        </SpTableColumn>
                      </SpTable>
                      <template #reference>
                        <SpProgress :progress="row.totalEmployed" />
                        <div v-if="row?.inService?.length > 0" class="attach">
                          {{ getDateToFormatEn(row.inService[0].hiredAt) }}
                        </div>
                      </template>
                    </sp-popover>
                  </div>
                </div>
              </template>
            </SpTable>
          </div>
        </sp-card>
      </div>
      <div class="flex-20 right-side sp-color-bg-4">
        <!-- 表格右边 -->
        <SpTable v-model:currPage="currPage" column-height="114" :data-list="dataList" width="1" class="table">
          <SpTableColumn column-name="CompanyName" label="CompanyName">
            <template #default="row">
              <div>{{ row.company?.name }}</div>
              <div class="attach">
                {{ row.company?.nativeName }}
              </div>
            </template>
          </SpTableColumn>
          <SpTableColumn column-name="EnteredBy" label="EnteredBy">
            <template #default="row">
              <div>{{ row.creatorName }}</div>
              <div class="attach">
                {{ getDateToFormatEn(row.createdAt) }}
              </div>
            </template>
          </SpTableColumn>
          <template #expand>
            <div class="expand" />
          </template>
        </SpTable>
      </div>
    </div>
    <!-- 点击more弹出的内容 -->
    <sp-drawer v-model="showMore" position="center" width="0.9" height="0.8">
      <DepartMentDetail :id="checkItem.id" />
    </sp-drawer>
    <!-- 点击图片弹出弹框 -->
    <sp-drawer v-model="showPic" position="center" width="0.5" height="0.5" type="dialog">
      <div class="flex-center max-box">
        <img :src="picSrc" class="of-contain">
      </div>
    </sp-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import spCard from '@/components/common/SpCard'
import spButton from '@/components/common/SpButton'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import spPopover from '@/components/common/SpPopover'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import SpTable from '@/components/common/SpTableDIY/SpTable.vue'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn.vue'
import spIcon from '@/components/common/SpIcon'
import SpProgress from '@/components/common/SpProgress'
import spDrawer from '@/components/common/SpDrawer'
import spDivider from '@/components/common/SpDivider'
import DepartMentDetail from './DepartMentDetail'
import {
  recycleEnterpriseDeptApi,
  deleteEnterpriseDeptApi,
  getEnterpriseDeptOwnedApi,
  trashEnterpriseDeptApi,
  getDeptEmployeeHistoryApi
} from '@/request/APIs/company'
import { IDENTITY_SHIP, IDENTITY_CARGO, IDENTITY_OP, IDENTITY_BROKER } from '@/config/company'
import SpMessage from '@/components/common/SpMessage'
import SpDialog from '@/components/common/SpDialog'
import FilterForm from '@/components/company/departmentDynamics/FilterForm'
import { getDateToFormatEn } from '@/utils/convert'
import _debounce from 'lodash/debounce'
import { getDeleterInfoApi } from '@/request/APIs/common'
import DeleteBy from '@/components/company/DeleteBy'
export default {
  name: 'DepartmentDynamics',

  nameSpace: 'company.DepartmentDynamics',
  components: {
    DeleteBy,
    FilterForm,
    spCard,
    spButton,
    spTag,
    spTagGroup,
    spPopover,
    spSelect,
    spSelectOption,
    SpTable,
    SpTableColumn,
    spIcon,
    SpProgress,
    spDrawer,
    spDivider,
    DepartMentDetail
  },

  data () {
    return {
      filterVisible: false,
      employVisible: false,
      dismissVisible: false,
      deptClass: 'all',
      checkItem: {},
      showMore: false,
      showInnerScroll: false,
      showPic: false,
      picSrc: '',
      dataList: [],
      currPage: 1,

      total: 0,
      pageSize: 0,

      getDateToFormatEn,
      accessIdentityOptions: {
        [IDENTITY_SHIP]: 'Shipowner',
        [IDENTITY_CARGO]: 'Charterer',
        [IDENTITY_BROKER]: 'CharteringBrokers',
        [IDENTITY_OP]: 'CharteringOperators'
      },

      companyCategory: {
        identity3: 'ShipOwnershipCompany', // 船主
        identity4: 'RightOfControlOfCargo', // 货主
        privContact: 'CompanyForCharteringBusinessExternalContacts', // 业务联系权
        privSign: 'UseForCPSigning' // 签约权
      },

      delInfo: {}

    }
  },

  computed: {
  },

  watch: {
    currPage (n) {
      this.getListing()
    },

    deptClass () {
      this.currPage = 1
      this.getListing()
    }
  },

  created () {
    this.getListing()
  },

  mounted () {
  },

  methods: {
    goEdit (row) {
      return this.$router.push({
        name: 'addDepartment',
        query: {
          id: row.id,
          nodeId: row.nodeId
        }
      })
    },

    showMoreDialog (row) {
      this.checkItem = row
      this.showMore = true
    },

    showPicFull (src) {
      this.picSrc = src
      this.showPic = true
    },

    // 获取部门动态列表
    getListing () {
      getEnterpriseDeptOwnedApi(this.deptClass, this.currPage).then(res => {
        this.dataList = res.data.data
        this.total = res.data.total
        this.pageSize = res.data.pageSize
      })
    },

    // 恢复删除的部门
    toRecycle (row) {
      recycleEnterpriseDeptApi(row.id).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
        this.getListing()
      })
    },

    // 删除公司
    toDelete (row) {
      SpDialog.Confirm({
        title: this.$l('tip'),
        content: this.$l('Delete Confirm'),
        height: 160,
        width: 300,
        callback: (code) => {
          if (code === 1) {
            let api = trashEnterpriseDeptApi
            if (this.deptClass === 'deleted') {
              api = deleteEnterpriseDeptApi // 强制删除
            }
            api(row.id).then(res => {
              SpMessage({
                message: res.message,
                type: 'success'
              })
              this.getListing()
            })
          }
        }
      })
    },

    getDeptEmployeeHistory (row, index) {
      getDeptEmployeeHistoryApi(row.id).then(res => {
        this.dataList[index].hired = res.data.hired
        this.dataList[index].dismissed = res.data.dismissed
        this.dataList[index].inService = res.data.inService
      })
    },

    getDeleter: _debounce(function (row) {
      this.delInfo = {}
      getDeleterInfoApi('dept', row.id, row.employerId).then(res => {
        if (res.code > 0) {
          this.delInfo = res.data
        }
      })
    }, 300)
  }
}
</script>

<style scoped lang="less">
// .filter-select{
//   width: 100%;
// }
.DepartmentDynamics {
  position: relative;
  .content {
    padding: @gap*2 @gap @gap @gap;
    .left-side {
      .card-content {
        padding: @gap 0 @gap @gap;
        .bt-item {
          padding: 0 @gap / 2;
        }
        .tags {
          margin-top: @gap;
        }
      }
      .employ-table {
        position: absolute;
        top: 50%;
        left: 50%;
      }
    }
    .right-side {
      padding: @gap;
      margin:  @gap*7+9 0 @gap 0;
    }
    .expand{
      padding:@gap;
      height:60px;
    }
  }
}
.expand-table {
  position: absolute;
  width: @gap*18;
  height: @gap*7;
  top: @gap*3.5;
  padding: @gap;
  left: -43px;
  background-color: #fff;
  .table-box {
    width: 100%;
    >tbody {
      >tr>td {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #be5b5b;
      }
    }
  }
}
.table-content {
  padding: 10px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid #d8d6d6;
}
.attach{
  color: #676767;
  font-size: 14px;
}
.dialog-more {
  padding:@gap*2 @gap @gap*3 @gap*2;
  @fontWeight:500;
  .item {
    margin: @gap/2 0;
    .title {
      font-weight: @fontWeight+50;
      opacity: .7;
    }
    .text {
      font-weight: @fontWeight+50;
      .tips {
        opacity: .6;
        font-weight: normal;
        font-size: 14px;
      }
    }
    .text-space {
      line-height: 1.6;
    }
  }
  .divider{
    margin:@gap 0 ;
  }
  .doments{
    color: #3A909D;
  }
}
</style>
